import { GetServerSideProps } from 'next';

import {
  Book,
  BookPageData,
} from '@/features/Book';
import { api } from '@/features/Book/api';

import { withNavigationData } from '@/utils/withNavigationData';

type PageProps = {
  config: BookPageData;
};

const Page = ({ config }: PageProps) => (
  <Book pageData={config} />
);

export const getServerSideProps: GetServerSideProps = withNavigationData(async context => {
  let config;

  try {
    const { data } = await api.getBookPage(
      { locale: context.locale }
    );

    config = data.data.attributes;
  } catch (error) {
    return {
      redirect: {
        destination: `/${context.locale}/404`,
        permanent: true,
      },
    };
  }

  return {
    props: {
      config,
    },
  };
});
export default Page;
